import cookie from 'js-cookie';
import config from './config';

const getLocale = () => cookie.get(config.LOCALE_KEY);

export default getLocale;



/** WEBPACK FOOTER **
 ** ./src/i18n/cookie.js
 **/